import {RouteNameEnum} from "@/v2/enumerate/route";

const worship = [{
	path: "worship",
	name: RouteNameEnum.GLORY_WORSHIP,
	meta: {
		permission: 66001,
		breadcrumb: [{
			key: "glory.worship.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/worship/index.vue"),
}];

export default worship;
